import { render, staticRenderFns } from "./SupplyForm.vue?vue&type=template&id=58b18b45&"
import script from "./SupplyForm.vue?vue&type=script&lang=js&"
export * from "./SupplyForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplyForm.vue?vue&type=style&index=0&id=58b18b45&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports